import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import { Redirect } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";
import { useForm } from "../../../hooks/useForm";
import {
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  cleanAfiliadoSeleccionado,
  cleanSolicitudes,
  clearReducer,
  getContadoresMedicacionBandeja,
  getMedicacionBandeja,
  getPatologiasEmp,
  setEstadoMedicacion
} from "../../../actions/empadronamiento/Empadronamiento";
import { EmpadronamientoAfiliadoBuscador } from "../Ingreso/EmpadronamientoAfiliadoBuscador";
import { MedicacionItem } from "./MedicacionItem";
import { EMPADRONAMIENTO_MEDICACION_ESTADOS } from "../../../utils/constants";
import { MEDICACION_MENU_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { startAlerta } from "../../../actions/ui/alertas";
import { Search } from "@material-ui/icons";

const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: 10,
    // width: "100%",
  },
  input: {
    padding: 10,
  },
  input2: {
    // padding: 10,
    paddingLeft: 10,
    paddingRight: 10
  },
});
const stateInitial = {
  idProfesional: null,
  fechaInicio: null,
  fechaFin: null,
  fechaCargaDesde: null,
  fechaCargaHasta: null,
  idPatologia: null
};
let arrayEstadosSolicitudes = [];

export const GestionBandejaMedicacionHome = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    afiliadoSeleccionado,
    idTipoEmpadronamiento,
    estadoMedicacion,
    solicitudes: items,
    solicitudesContadores,
    patologiasEmpadronamiento
  } = useSelector((state) => state.empadronamiento);
  const { areas = [], bandejasAutorizacion = [], permisos: permisosUser } = useSelector(
    (state) => state.auth
  );

  const [formValues, , , setearValor] = useForm(stateInitial);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [redirect, setRedirect] = useState(false);
  const { fechaInicio, fechaFin, fechaCargaDesde, fechaCargaHasta, idPatologia } = formValues;
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const [idSolicitud, setIdSolicitud] = useState(null);
  const [idSolicitudEmp, setIdSolicitudEmp] = useState(null);
  const [nroPedido, setNroPedido] = useState(null);

  useEffect(() => {
    if (!props.location.state?.fromHomeScreen) {
      dispatch(clearReducer());
      dispatch(cleanSolicitudes());
      dispatch(cleanAfiliadoSeleccionado());
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(getPatologiasEmp(idTipoEmpadronamiento))
  }, [dispatch]);

  useEffect(() => {
    arrayEstadosSolicitudes = Object.entries(EMPADRONAMIENTO_MEDICACION_ESTADOS);
  }, [areas, bandejasAutorizacion]);

  useEffect(() => {
    traerSolicitudes();
  }, [
    dispatch,
    afiliadoSeleccionado?.id_afiliado,
    fechaInicio,
    fechaFin,
    estadoMedicacion,
    idPatologia,
    fechaCargaDesde,
    fechaCargaHasta,
  ]);

  useEffect(() => {
    traerContadores();
  }, [
    dispatch,
    afiliadoSeleccionado?.id_afiliado,
    fechaInicio,
    fechaFin,
    estadoMedicacion,
    idPatologia,
    fechaCargaDesde,
    fechaCargaHasta,
  ]);

  const traerContadores = () => {
    dispatch(
      getContadoresMedicacionBandeja(
        afiliadoSeleccionado?.id_afiliado,
        idSolicitud,
        idTipoEmpadronamiento,
        fechaInicio,
        fechaFin,
        fechaCargaDesde,
        fechaCargaHasta,
        idPatologia,
        idSolicitudEmp,
        nroPedido,
        parseInt(estadoMedicacion),
        validarSoloUnPermiso(
          permisosUser,
          MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
        ),
        validarSoloUnPermiso(
          permisosUser,
          MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
        ),
        validarSoloUnPermiso(
          permisosUser,
          MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
        ))
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const buscarConParametros = () => {
    traerContadores();
    traerSolicitudes();
  };


  const traerSolicitudes = () => {
    if (arrayEstadosSolicitudes.filter(s => s[1] === parseInt(estadoMedicacion)).length > 0) {
      if (parseInt(estadoMedicacion) !== EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA) {
        dispatch(
          getMedicacionBandeja(
            afiliadoSeleccionado?.id_afiliado,
            idSolicitud,
            idTipoEmpadronamiento,
            fechaInicio,
            fechaFin,
            fechaCargaDesde,
            fechaCargaHasta,
            idPatologia,
            idSolicitudEmp,
            nroPedido,
            parseInt(estadoMedicacion),
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
            ),
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ),
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
            ),
            false
          )
        );
        setPage(0);
      } else {
        if (afiliadoSeleccionado?.id_afiliado !== undefined
          || (idSolicitud !== "" && idSolicitud !== undefined && idSolicitud !== null)
          || (idSolicitudEmp !== "" && idSolicitudEmp !== undefined && idSolicitudEmp !== null)
          || (nroPedido !== "" && nroPedido !== undefined && nroPedido !== null)
          || (fechaInicio !== null && fechaFin !== null)
          || (fechaCargaDesde !== null && fechaCargaHasta !== null)) {
          const fechaInicioMoment = moment(fechaInicio);
          const fechaFinMoment = moment(fechaFin);
          const diffInDays = fechaFinMoment.diff(fechaInicioMoment, 'days');
          const fechaDesdeMoment = moment(fechaCargaDesde);
          const fechaHastaMoment = moment(fechaCargaHasta);
          const diffInDays2 = fechaHastaMoment.diff(fechaDesdeMoment, 'days');

          if ((diffInDays <= 90 || (fechaInicio === null && fechaFin === null)) &&
            (diffInDays2 <= 90 || (fechaCargaDesde === null && fechaCargaHasta === null))) {
            dispatch(
              getMedicacionBandeja(
                afiliadoSeleccionado?.id_afiliado,
                idSolicitud,
                idTipoEmpadronamiento,
                fechaInicio,
                fechaFin,
                fechaCargaDesde,
                fechaCargaHasta,
                idPatologia,
                idSolicitudEmp,
                nroPedido,
                parseInt(estadoMedicacion),
                validarSoloUnPermiso(
                  permisosUser,
                  MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
                ),
                validarSoloUnPermiso(
                  permisosUser,
                  MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
                ),
                validarSoloUnPermiso(
                  permisosUser,
                  MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
                ),
                false
              )
            );
            setPage(0);
          } else {
            dispatch(
              startAlerta(
                "Las diferencia entre la fecha desde y hasta no pueden ser mayor a 90 días.",
                "warning"
              )
            );
            dispatch(cleanSolicitudes());
          }
        } else {
          dispatch(
            startAlerta(
              "Debe filtrar por afiliado, N° de Medicación, N° de Empadronamiento, N° de pedido o fecha desde/hasta",
              "warning"
            )
          );
          dispatch(cleanSolicitudes());
        }
      }
    }
  };

  const componentRef = React.useRef();

  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={6}>
            <EmpadronamientoAfiliadoBuscador hideTitle={true} />
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input2}>
              <TextField
                margin="normal"
                // InputProps={{ classes: { input: classes.NroAfi } }}
                fullWidth
                type='number'
                label="Medicacion N°"
                name="idSolicitud"
                value={idSolicitud}
                autoComplete="off"
                disabled={false}
                onChange={(e) => {
                  if (e.target.value === '' || e.target.value > 0) setIdSolicitud(e.target.value)
                }}
                onKeyUp={(e) => { if (e.key === 'Enter') buscarConParametros() }}
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Buscar"
                        onClick={buscarConParametros}
                        disabled={false}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input2}>
              <TextField
                margin="normal"
                // InputProps={{ classes: { input: classes.NroAfi } }}
                fullWidth
                type='number'
                label="Empadronamiento N°"
                name="idSolicitudEmp"
                value={idSolicitudEmp}
                autoComplete="off"
                disabled={false}
                onChange={(e) => {
                  if (e.target.value === '' || e.target.value > 0) setIdSolicitudEmp(e.target.value)
                }}
                onKeyUp={(e) => { if (e.key === 'Enter') buscarConParametros() }}
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Buscar"
                        onClick={buscarConParametros}
                        disabled={false}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input2}>
              <TextField
                margin="normal"
                // InputProps={{ classes: { input: classes.NroAfi } }}
                fullWidth
                type='number'
                label="Pedido N°"
                name="nroPedido"
                value={nroPedido}
                autoComplete="off"
                disabled={false}
                onChange={(e) => {
                  if (e.target.value === '' || e.target.value > 0) setNroPedido(e.target.value)
                }}
                onKeyUp={(e) => { if (e.key === 'Enter') buscarConParametros() }}
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Buscar"
                        onClick={buscarConParametros}
                        disabled={false}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                }}
              />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={4}>
            <Paper className={classes.input}>
              <FormControl fullWidth>
                <InputLabel id="select-patologia-label">Patologia</InputLabel>
                <Select
                  labelId="select-patologia-label"
                  id="select-patologia"
                  value={idPatologia}
                  onChange={(e) => { setearValor("idPatologia", e.target.value) }}
                  label="Patología"
                >
                  {patologiasEmpadronamiento.map((patologia) => (
                    <MenuItem key={patologia.idPatologia} value={patologia.idPatologia}>
                      {patologia.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="Inicio Desde"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(fechaInicio).isValid() ? moment(fechaInicio) : null
                  }
                  onChange={(date) => {
                    setearValor("fechaInicio", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="Inicio Hasta"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={moment(fechaFin).isValid() ? moment(fechaFin) : null}
                  onChange={(date) => {
                    setearValor("fechaFin", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="Carga Desde"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(fechaCargaDesde).isValid() ? moment(fechaCargaDesde) : null
                  }
                  onChange={(date) => {
                    setearValor("fechaCargaDesde", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="Carga Hasta"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={moment(fechaCargaHasta).isValid() ? moment(fechaCargaHasta) : null}
                  onChange={(date) => {
                    setearValor("fechaCargaHasta", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Paper style={{ padding: "0.25rem" }}>
          <RadioGroup
            row
            style={{ justifyContent: "space-around" }}
            value={estadoMedicacion}
            onChange={(e) => {
              dispatch(setEstadoMedicacion(e.target.value));
            }}
          >
            {arrayEstadosSolicitudes.filter(e => /*parseInt(e[1]) !== EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA &&*/
              parseInt(e[1]) !== EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION)
              .map((estadoSolicitud) => {
                const contador = solicitudesContadores.find(s => s.idEstado === estadoSolicitud[1]);
                const label =
                  estadoSolicitud[0].charAt(0) +
                  estadoSolicitud[0].replace("_", " ").toLowerCase().slice(1) +
                  ((contador && contador !== undefined)
                    ?
                    `(${contador.total})`
                    :
                    `(...)`
                  );
                return (
                  <FormControlLabel
                    key={estadoSolicitud[1]?.toString()}
                    style={{ marginLeft: "0.5rem" }}
                    label={label}
                    value={estadoSolicitud[1]?.toString()}
                    control={<Radio />}
                  />
                );
              })}
          </RadioGroup>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHead>
              <TableRow>
                <TableCell align="left"></TableCell>
                <TableCell align="left"></TableCell>
                <TableCell align="left"></TableCell>
                <TableCell align="left">Carga</TableCell>
                <TableCell align="left">Fecha</TableCell>
                {/*<TableCell align="left">Fin</TableCell>*/}
                <TableCell align="left">Medicación N°</TableCell>
                <TableCell align="left">Empadronamiento N°</TableCell>
                <TableCell align="left">Programa</TableCell>
                <TableCell align="left">Patología</TableCell>
                <TableCell align="left">Medicamentos</TableCell>
                <TableCell align="left">Paciente</TableCell>
                <TableCell align="left">N° Afiliado</TableCell>
                <TableCell align="left">N° Pedido SC</TableCell>
                <TableCell align="left"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length > 0 ? (
                items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <MedicacionItem
                      item={item}
                      setRedirect={setRedirect}
                      permisosUser={permisosUser}
                      key={item.idSolicitud?.toString()}
                      estadoMedicacion={estadoMedicacion}
                      expandirMedicamentos={false}
                      filtros={
                        {
                          idAfiliado: afiliadoSeleccionado?.id_afiliado,
                          idSolicitud,
                          idSolicitudEmp,
                          nroPedido,
                          idPatologia,
                          idTipoEmpadronamiento,
                          fechaDesde: fechaInicio,
                          fechaHasta: fechaFin,
                          fechaCargaDesde,
                          fechaCargaHasta,
                          idEstadoSolicitud: parseInt(estadoMedicacion),
                          esAuditor: validarSoloUnPermiso(
                            permisosUser,
                            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
                          ),
                          esAuditorEsp: validarSoloUnPermiso(
                            permisosUser,
                            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
                          ),
                          esAuditorDisca: validarSoloUnPermiso(
                            permisosUser,
                            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
                          )
                        }
                      }
                      {...props}
                    />
                  ))
              ) : (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "-webkit-center" }}
                  >
                    {" "}
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {items.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
      {redirect && (
        <Redirect
          to={{
            pathname: '/medicacion',
            state: {
              from: '/medicacion/gestion'
            },
          }}
        />
      )}
    </Grid>
  );
};
